//-------------------------------------------------------------------------
// 
// !!! Do not edit this file manually !!!
// 
// This file was autogenerated from the Frontier primitives variables
// 
// Run "npm run build-primitives" to rebuild it
// 
//-------------------------------------------------------------------------

import { css } from "./styledSystem";

export const inputStyles = css`
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
	font-weight: 400;
	line-height: 1.3;
	border: 1px solid #e1e4e8;
	border-radius: 4px;
	vertical-align: middle;
	display: inline-block;
	margin: 0;
	color: inherit;
	background-color: #ffffff;
	background-clip: padding-box;

	// Unstyle the caret on <select>s in IE10+.
	&::-ms-expand {
		background-color: transparent;
		border: 0;
	}

	// Customize the :focus state to imitate native WebKit styles.
	&:focus {
		outline: 0;
		box-shadow: 0 0 0 3px rgba(0,76,199,0.3);
	}

	// Placeholder
	&::placeholder {
		color: #959da5;
		// Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.
		opacity: 1;
	}

	// Disabled and read-only inputs
	&:disabled,
	&[readonly] {
		background-color: #e1e4e8;
		border-color: transparent;
		color: #959da5;
		// iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.
		opacity: 1;
	}
	
`;

export const inputSelectStyles = css`
	background: #ffffff url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA1LjMzMzM0TDggMS4zMzMzNEwxMiA1LjMzMzM0IiBzdHJva2U9IiMyRjM2M0QiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTEyIDEwLjY2NjdMOCAxNC42NjY3TDQgMTAuNjY2NyIgc3Ryb2tlPSIjMkYzNjNEIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==") no-repeat right 12px center;
	background-size: 12px 12px;
	background-repeat: no-repeat;
	background-position: right 6px center;
	appearance: none;
	padding-right: 28px;

	// Height auto when multiple or size specified
	&[size],
	&[multiple] {
		height: auto;
		background-image: none;
	}

	// Hides the default caret in IE11
	&::-ms-expand {
		opacity: 0;
	}
	
`;

export const inputSizes: {[name: string]: any } = {
	default: css`
		font-size: 14px;
		height: calc(1.30em + 18px);
		padding-left: 16px;
		padding-right: 16px;
		padding-top: 8px;
		padding-bottom: 8px;
	`,
	sm: css`
		font-size: 14px;
		height: calc(1.30em + 14px);
		padding-left: 16px;
		padding-right: 16px;
		padding-top: 6px;
		padding-bottom: 6px;
	`,
	lg: css`
		font-size: 16px;
		height: calc(1.13em + 26px);
		padding-left: 16px;
		padding-right: 16px;
		padding-top: 8px;
		padding-bottom: 8px;
	`,
	font: css`
		font-size: inherit;
		height: auto;
		padding-left: 1.25em;
		padding-right: 1.25em;
		padding-top: 0.75em;
		padding-bottom: 0.75em;
	`,
};

export const inputVariants = {
	contrast: css`
		background-color: #f6f8fa;
		&:focus { background-color: #ffffff; }
	`,
	dark: css`
		color: #ffffff !important;
		background-color: rgba(255,255,255,0.15);
		border-color: transparent;
		caret-color: rgba(255,255,255,0.70);
		&::placeholder {
			color: rgba(255,255,255,0.50) !important;
			opacity: 0.4;
		}
		&.focus, &:focus {
			border-color: rgba(27,31,35,0.30);
			background-color: rgba(255,255,255,0.15);
		}
	`,
	plain: css`
		border-color: transparent !important;
		background-color: transparent !important;
		box-shadow: none;
		&:disabled, &[readonly] {
			color: inherit !important;
		}
	`,
}
